import { render, staticRenderFns } from "./PaintConfig.vue?vue&type=template&id=7e5f0d1e&scoped=true&"
import script from "./PaintConfig.vue?vue&type=script&lang=js&"
export * from "./PaintConfig.vue?vue&type=script&lang=js&"
import style0 from "./PaintConfig.vue?vue&type=style&index=0&id=7e5f0d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f0d1e",
  null
  
)

export default component.exports